import { Link } from "@quintype/components";
import React from "react";
import "./hamburger-epaper-button.m.css";

const EPAPER_BASE_URL = "https://epaper.prajavani.net/";

const buildEpaperUrl = () => {
  // Guaranteed order: utm_source → utm_medium → utm_campaign
  return `${EPAPER_BASE_URL}?utm_source=pvsite&utm_medium=headerbutton&utm_campaign=awareness`;
};

function HamuburgerEPaperButton() {
  const epaperUrl = buildEpaperUrl();

  return (
    <div styleName="epaper-wrapper">
      <Link href={epaperUrl} styleName="e-paper-btn" target="_blank">
        Read ePaper
      </Link>
    </div>
  );
}

export default HamuburgerEPaperButton;
